// Text-only wordmark: heavy "EXO" against a light, widely-tracked "PILOT" --
// the weight contrast is what makes it read as a logo rather than plain text.
export const Logo = ({ inverted = false, suffix = "", className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <span className={`font-heading text-[1.4rem] leading-none uppercase whitespace-nowrap ${inverted ? "text-white" : "text-[#111] dark:text-white"}`}>
      <span className="font-black tracking-[-0.02em]">EXO</span>
      <span className="font-light tracking-[0.24em] ml-[0.12em]">PILOT</span>
    </span>
    {suffix && (
      <span className="text-[10px] uppercase tracking-[0.22em] mt-0.5 text-neutral-400 border-l border-neutral-300 dark:border-neutral-700 pl-2.5">{suffix}</span>
    )}
  </span>
);
